<template>
  <div class="list-panel">
    <div class="main-container">
      <div class="tab-con">
        <el-menu  :default-active="activeIndex" class="el-menu-demo" mode="horizontal" @select="handleSelect">
          <el-menu-item index="list">全部商务供应商列表</el-menu-item>
		      <el-menu-item index="add">创建商务供应商</el-menu-item>
        </el-menu>
      </div>
      <div class="content-wrap">
        <List v-if="activeIndex == 'list'" ></List>
        <Add v-if="activeIndex == 'add'" pageType="add"></Add>
      </div>
    </div>
  </div>
</template>

<script>
import List from './component/list.vue';
import Add from './component/form.vue';
export default {
  data() {
    return {
      activeIndex: "list",
    };
  },
  components: {
	  List,
    Add
  },
  methods: {
    handleSelect(key, keyPath){
      this.activeIndex = key;
    },

  },
};
</script>